(function () {
  'use strict';

  function money(cents, locale) {
    try {
      return new Intl.NumberFormat(locale || 'es-ES', {
        style: 'currency', currency: 'EUR', minimumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' €';
    }
  }

  window.cdpDeliveryCalculator = function (config) {
    config = config || {};
    return {
      locale: config.locale || 'es-ES',
      storeOriginAddress: config.storeOriginAddress || '',
      deliveryZoneTable: Array.isArray(config.deliveryZoneTable) ? config.deliveryZoneTable : [],
      t: config.t || {},

      address: '',
      status: 'idle', // idle | calculating | ready | out_of_range | error
      message: '',
      zoneLabel: '',
      feeCents: 0,

      init: function () {
        var self = this;
        this.$nextTick(function () { self.initPlacesAutocomplete(); });
      },

      formatPrice: function (cents) { return money(cents, this.locale); },

      initPlacesAutocomplete: function () {
        if (!window.google || !window.google.maps || !window.google.maps.places) return;
        var input = document.getElementById('cdp-dc-address');
        if (!input || input._cdpAutocompleteBound) return;
        input._cdpAutocompleteBound = true;
        var self = this;
        var autocomplete = new google.maps.places.Autocomplete(input, {
          componentRestrictions: { country: 'es' },
          fields: ['formatted_address', 'geometry']
        });
        autocomplete.addListener('place_changed', function () {
          var place = autocomplete.getPlace();
          if (!place || !place.geometry) return;
          self.address = place.formatted_address || self.address;
          self.computeDeliveryFee(place.geometry.location);
        });
      },

      computeDeliveryFee: function (destination) {
        var self = this;
        if (!window.google || !window.google.maps || !window.google.maps.DistanceMatrixService) {
          this.status = 'error';
          this.message = this.t.error_delivery_fee_failed || 'Could not calculate the delivery fee — please try again.';
          return;
        }
        this.status = 'calculating';
        this.message = this.t.delivery_fee_calculating || 'Calculating delivery fee…';
        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix({
          origins: [self.storeOriginAddress],
          destinations: [destination],
          travelMode: 'DRIVING'
        }, function (response, status) {
          var el = status === 'OK' && response.rows[0] && response.rows[0].elements[0];
          if (!el || el.status !== 'OK') {
            self.status = 'error';
            self.message = self.t.error_delivery_fee_failed || 'Could not calculate the delivery fee — please try again.';
            return;
          }
          var km = el.distance.value / 1000;
          var zone = null;
          for (var i = 0; i < self.deliveryZoneTable.length; i++) {
            if (km <= self.deliveryZoneTable[i].maxKm) { zone = self.deliveryZoneTable[i]; break; }
          }
          if (!zone) {
            self.status = 'out_of_range';
            self.message = self.t.delivery_out_of_range || "Sorry, we don't currently deliver that far — message us on WhatsApp.";
            self.feeCents = 0;
            self.zoneLabel = '';
            return;
          }
          self.feeCents = zone.feeCents;
          self.zoneLabel = 'Zone ' + zone.zoneNumber;
          self.status = 'ready';
          self.message = '';
        });
      }
    };
  };
})();
